import { memo, useEffect } from "react";
import HealthIncNotificaMessageBody from "../HealthIncNotificaMessageBody/HealthIncNotificaMessageBody";
import { useAllRelatives } from "../../../../customHooks/useAllRelatives";
import usePermissions from "../../../../customHooks/usePermissions";
import useDisciplinaryCases from "../../../../customHooks/useDisciplinaryCases";

function HealthIncNotificaForHrToReviewUploadedRelData() {
  const { handleGetRelativesData, searchResult } = useAllRelatives();
  const { checkPermissionAndThrow } = usePermissions();

  useEffect(() => {
    handleGetRelativesData("", "WAITING", 1);
  }, []);

  // 🔹 تحديد status حسب الصلاحيات
  let status = null;

  if (checkPermissionAndThrow("hr_review_disciplinary_cases")) {
    status = "pending_hr_approval";
  } else if (checkPermissionAndThrow("department_head_review_disciplinary_cases")) {
    status = "pending_department_head_approval";
  } else if (checkPermissionAndThrow("factory_manager_review_disciplinary_cases")) {
    status = "pending_factory_manager_approval";
  }

  // 🔹 جلب البيانات من API حسب status
  const { data: disciplinaryData } = useDisciplinaryCases({
    page: 1,
    filters: {
      status: status || undefined,
    },
  });

  // 🔥 شرط العرض النهائي
  const shouldShowNotification =
    status !== null && disciplinaryData?.length > 0;

  return (
    <>
      {/* 🔹 Notification 1 */}
      {searchResult && searchResult.length !== 0 && (
        <div className="show_notifi_container">
          <HealthIncNotificaMessageBody
            notifText={"بعض بيانات التأمين الصحي بحاجة الى مراجعة"}
            btnText={"انتقال"}
            btnLink={"/emp/h_insurance_manage_relatives_data"}
          />
        </div>
      )}

      {/* 🔹 Notification 2 (حسب البيانات + الصلاحية) */}
      {shouldShowNotification && (
        <div className="show_notifi_container">
          <HealthIncNotificaMessageBody
            notifText={"بعض القضايا التأديبية بحاجة الى مراجعة"}
            btnText={"انتقال"}
            btnLink={"/emp/disciplinary_cases"}
            state={{
              status,
            }}
          />
        </div>
      )}
    </>
  );
}

export default memo(HealthIncNotificaForHrToReviewUploadedRelData);